import React from 'react';

const AlignmentGuides = ({ currentScreen }) => {
  if (!currentScreen) return null;

  const { width, height } = currentScreen.layout;

  return (
    <>
      {/* Center Lines with Labels */}
      <div
        className="absolute top-0 bottom-0 border-l-2 border-dashed border-primary-400 pointer-events-none"
        style={{ left: `${width / 2}px` }}
      >
        <div className="absolute top-2 left-2 whitespace-nowrap rounded-md bg-primary-600 px-1.5 py-0.5 text-[10.5px] font-medium text-white pointer-events-none">
          H Center
        </div>
      </div>
      <div
        className="absolute left-0 right-0 border-t-2 border-dashed border-primary-400 pointer-events-none"
        style={{ top: `${height / 2}px` }}
      >
        <div className="absolute top-2 left-2 whitespace-nowrap rounded-md bg-primary-600 px-1.5 py-0.5 text-[10.5px] font-medium text-white pointer-events-none">
          V Center
        </div>
      </div>
      
      {/* Center Crosshair */}
      <div
        className="absolute w-3 h-3 pointer-events-none"
        style={{ 
          left: `${width / 2 - 6}px`,
          top: `${height / 2 - 6}px`
        }}
      >
        <div className="w-3 h-3 rounded-full bg-primary-500 opacity-70 pointer-events-none" />
      </div>
      
      {/* Third Lines */}
      <div
        className="absolute top-0 bottom-0 border-l border-dashed border-gray-300 pointer-events-none opacity-60"
        style={{ left: `${width / 3}px` }}
      />
      <div
        className="absolute top-0 bottom-0 border-l border-dashed border-gray-300 pointer-events-none opacity-60"
        style={{ left: `${(width * 2) / 3}px` }}
      />
      <div
        className="absolute left-0 right-0 border-t border-dashed border-gray-300 pointer-events-none opacity-60"
        style={{ top: `${height / 3}px` }}
      />
      <div
        className="absolute left-0 right-0 border-t border-dashed border-gray-300 pointer-events-none opacity-60"
        style={{ top: `${(height * 2) / 3}px` }}
      />
      
      {/* Quarter Lines */}
      <div
        className="absolute top-0 bottom-0 border-l border-dotted border-gray-200 pointer-events-none opacity-30"
        style={{ left: `${width / 4}px` }}
      />
      <div
        className="absolute top-0 bottom-0 border-l border-dotted border-gray-200 pointer-events-none opacity-30"
        style={{ left: `${(width * 3) / 4}px` }}
      />
    </>
  );
};

export default AlignmentGuides;
